import Seo from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { SITE } from "@/config/site";

const SECTIONS = [
  {
    title: "Information we collect",
    text: "This website does not collect, store or process personal information on any server. Appointment and contact forms on this website open WhatsApp on your own device — the message is composed and sent by you directly to the hospital.",
  },
  {
    title: "WhatsApp communication",
    text: "When you use a WhatsApp button or form on this website, your message is handled by WhatsApp according to WhatsApp's own privacy policy. Please avoid sharing sensitive medical documents unless the hospital team asks for them.",
  },
  {
    title: "How the hospital uses your information",
    text: "Information you share with the hospital by phone or WhatsApp (such as your name, mobile number and reason for visit) is used only to arrange and confirm your appointment and to provide care.",
  },
  {
    title: "Data security",
    text: "Since this website does not store patient information in any database, there is no patient data held by the website itself. Any information shared directly with the hospital is handled with confidentiality.",
  },
  {
    title: "Changes to this policy",
    text: "This policy may be updated as the website and hospital services evolve. Please check this page periodically for the latest version.",
  },
];

export default function PrivacyPolicy() {
  return (
    <>
      <Seo
        title={`Privacy Policy — ${SITE.name}`}
        siteName={SITE.name}
        description={`Privacy policy of ${SITE.name}, Kasdol — how appointment requests and contact information are handled.`}
      />
      <PageHeader title="Privacy Policy" description="How this website and the hospital handle your information." crumbs={[{ label: "Privacy Policy" }]} />
      <section className="py-14 sm:py-20" data-testid="privacy-section">
        <div className="mx-auto max-w-3xl space-y-8 px-4 sm:px-6 lg:px-8">
          {SECTIONS.map((s, i) => (
            <div key={s.title} className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8" data-testid={`privacy-section-${i}`}>
              <h2 className="font-heading text-lg font-semibold text-navy-900">{i + 1}. {s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.text}</p>
            </div>
          ))}
          <p className="text-center text-xs text-slate-500">
            Questions about privacy? Call us on {SITE.phoneDisplay}.
          </p>
        </div>
      </section>
    </>
  );
}
